// 指标说明映射（根据 COIN_METRICS_INDICATORS_GUIDE.md 文档）
export const indicatorDescriptions: { [key: string]: { name: string; description: string; category: string } } = {
  // ========= 基础信息 =========
  id: { name: '记录ID', description: '内部主键ID', category: '系统字段' },
  lastUpdated: { name: '最后更新', description: '该记录最近一次更新时间', category: '系统字段' },
  createdAt: { name: '创建时间', description: '记录创建时间', category: '系统字段' },
  updatedAt: { name: '更新时间', description: '记录更新时间', category: '系统字段' },
  dataSource: { name: '数据来源', description: '如 OKX、内部计算等', category: '系统字段' },
  dataQuality: { name: '数据质量', description: '数据完整性/可信度评分', category: '系统字段' },
  syncStatus: { name: '同步状态', description: '数据同步是否成功', category: '系统字段' },
  syncError: { name: '同步错误', description: '同步过程中的错误信息', category: '系统字段' },

  // ========= 价格数据 =========
  price: { name: '当前价格', description: '币种的最新成交价格（来自 market_data.last）', category: '价格数据' },

  open24h: { name: '24小时开盘价', description: '过去24小时区间的开盘价', category: '价格数据' },
  high24h: { name: '24小时最高价', description: '过去24小时内的最高价', category: '价格数据' },
  low24h: { name: '24小时最低价', description: '过去24小时内的最低价', category: '价格数据' },

  open7d: { name: '7天开盘价', description: '过去7天区间的开盘价', category: '价格数据' },
  high7d: { name: '7天最高价', description: '过去7天内的最高价', category: '价格数据' },
  low7d: { name: '7天最低价', description: '过去7天内的最低价', category: '价格数据' },

  open30d: { name: '30天开盘价', description: '过去30天区间的开盘价', category: '价格数据' },
  high30d: { name: '30天最高价', description: '过去30天内的最高价', category: '价格数据' },
  low30d: { name: '30天最低价', description: '过去30天内的最低价', category: '价格数据' },

  open1y: { name: '1年开盘价', description: '过去1年区间的开盘价', category: '价格数据' },
  high1y: { name: '1年最高价', description: '过去1年内的最高价', category: '价格数据' },
  low1y: { name: '1年最低价', description: '过去1年内的最低价', category: '价格数据' },

  allTimeHigh: { name: '历史最高价', description: '全历史区间的最高价格（来自日K/历史数据）', category: '价格数据' },
  allTimeLow: { name: '历史最低价', description: '全历史区间的最低价格（来自日K/历史数据）', category: '价格数据' },
  allTimeHighDate: { name: '历史最高价日期', description: '历史最高价格出现日期', category: '价格数据' },
  allTimeLowDate: { name: '历史最低价日期', description: '历史最低价格出现日期', category: '价格数据' },

  // ========= 价格变化率 =========
  change1h: { name: '1小时价格变化', description: '近1小时价格变化（绝对值）', category: '价格变化' },
  changePct1h: { name: '1小时涨跌幅', description: '近1小时价格变化百分比', category: '价格变化' },

  change4h: { name: '4小时价格变化', description: '近4小时价格变化（绝对值）', category: '价格变化' },
  changePct4h: { name: '4小时涨跌幅', description: '近4小时价格变化百分比', category: '价格变化' },

  change24h: { name: '24小时价格变化', description: '近24小时价格变化（绝对值）', category: '价格变化' },
  changePct24h: { name: '24小时涨跌幅', description: '近24小时价格变化百分比', category: '价格变化' },

  change7d: { name: '7天价格变化', description: '近7天价格变化（绝对值）', category: '价格变化' },
  changePct7d: { name: '7天涨跌幅', description: '近7天价格变化百分比', category: '价格变化' },

  change30d: { name: '30天价格变化', description: '近30天价格变化（绝对值）', category: '价格变化' },
  changePct30d: { name: '30天涨跌幅', description: '近30天价格变化百分比', category: '价格变化' },

  change90d: { name: '90天价格变化', description: '近90天价格变化（绝对值）', category: '价格变化' },
  changePct90d: { name: '90天涨跌幅', description: '近90天价格变化百分比', category: '价格变化' },

  change1y: { name: '1年价格变化', description: '近1年价格变化（绝对值）', category: '价格变化' },
  changePct1y: { name: '1年涨跌幅', description: '近1年价格变化百分比', category: '价格变化' },

  // ========= 成交量数据 =========
  volume24h: { name: '24小时成交量', description: '过去24小时成交量（币本位）', category: '成交量' },

  volume7d: { name: '7天成交量', description: '过去7天成交量（币本位）', category: '成交量' },

  volume30d: { name: '30天成交量', description: '过去30天成交量（币本位）', category: '成交量' },

  turnover24h: { name: '24小时成交额', description: '价格 × 成交量（约等于 USD 计成交额）', category: '成交量' },
  turnover7d: { name: '7天成交额', description: '近7天资金成交额规模', category: '成交量' },
  turnover30d: { name: '30天成交额', description: '近30天资金成交额规模', category: '成交量' },

  avgVolume24h: { name: '24小时平均成交量', description: '近24小时平均成交量（可用于异常度判断）', category: '成交量' },
  avgVolume7d: { name: '7天平均成交量', description: '近7天日均成交量（基于日K）', category: '成交量' },
  avgVolume30d: { name: '30天平均成交量', description: '近30天日均成交量（基于日K）', category: '成交量' },

  // ========= 买卖盘/深度 =========
  bidPx: { name: '买一价', description: '当前订单簿最佳买价', category: '买卖盘' },
  bidSz: { name: '买一量', description: '当前订单簿最佳买量', category: '买卖盘' },
  askPx: { name: '卖一价', description: '当前订单簿最佳卖价', category: '买卖盘' },
  askSz: { name: '卖一量', description: '当前订单簿最佳卖量', category: '买卖盘' },

  spread: { name: '价差', description: '卖一价 - 买一价（绝对值）', category: '买卖盘' },
  spreadPct: { name: '价差百分比', description: '(askPx - bidPx) / bidPx × 100', category: '买卖盘' },
  bidAskRatio: { name: '买卖盘比例', description: 'bidSz / askSz，衡量买盘与卖盘强弱', category: '买卖盘' },

  depth10: { name: '10档深度', description: '前10档累计市场深度', category: '买卖盘' },
  depth20: { name: '20档深度', description: '前20档累计市场深度', category: '买卖盘' },

  // ========= 市值与供应 =========
  marketCap: { name: '市值', description: '价格 × 流通供应量', category: '市值与供应' },
  marketCapRank: { name: '市值排名', description: '按市值从大到小的名次', category: '市值与供应' },
  fullyDilutedMarketCap: { name: '完全稀释市值', description: '价格 × 最大供应量', category: '市值与供应' },
  circulatingSupply: { name: '流通供应量', description: '当前在市场中流通的代币数量', category: '市值与供应' },
  totalSupply: { name: '总供应量', description: '已发行的代币总量', category: '市值与供应' },
  maxSupply: { name: '最大供应量', description: '协议或设计的最大发行上限（若有）', category: '市值与供应' },
  supplyChange24h: { name: '24小时供应量变化', description: '近24小时供应量变化（绝对值）', category: '市值与供应' },
  supplyChangePct24h: { name: '24小时供应变化率', description: '近24小时供应量变化百分比', category: '市值与供应' },

  // ========= 流动性 =========
  liquidity24h: { name: '24小时流动性', description: '衡量承载大额交易而不显著影响价格的能力', category: '流动性' },
  liquidityScore: { name: '流动性评分', description: '综合流动性评分（0-100）', category: '流动性' },
  depthScore: { name: '深度评分', description: '订单簿深度质量评分', category: '流动性' },
  slippage1pct: { name: '1%滑点', description: '执行 1% 订单量时预计的价格滑点', category: '流动性' },
  slippage5pct: { name: '5%滑点', description: '执行 5% 订单量时预计的价格滑点', category: '流动性' },
  illiquidityScore: { name: '非流动性评分', description: '越高表示越不流动', category: '流动性' },

  // ========= 波动性 =========
  volatility24h: { name: '24小时波动率', description: '基于收益率标准差的年化/区间波动', category: '波动性' },
  volatility7d: { name: '7天波动率', description: '同上，统计窗口为7天', category: '波动性' },
  volatility30d: { name: '30天波动率', description: '同上，统计窗口为30天', category: '波动性' },
  volatility90d: { name: '90天波动率', description: '同上，统计窗口为90天', category: '波动性' },
  volatility1y: { name: '1年波动率', description: '同上，统计窗口为1年', category: '波动性' },
  atr14: { name: 'ATR(14)', description: '14周期平均真实波幅，常用于止损与仓位管理', category: '波动性' },
  atr24: { name: 'ATR(24)', description: '24周期平均真实波幅', category: '波动性' },

  // ========= 技术指标（示例子集，可扩展） =========
  // 趋势类
  sma5: { name: 'SMA5', description: '5日简单移动平均线', category: '技术指标-趋势' },
  sma10: { name: 'SMA10', description: '10日简单移动平均线', category: '技术指标-趋势' },
  sma20: { name: 'SMA20', description: '20日简单移动平均线', category: '技术指标-趋势' },
  sma30: { name: 'SMA30', description: '30日简单移动平均线', category: '技术指标-趋势' },
  sma50: { name: 'SMA50', description: '50日简单移动平均线', category: '技术指标-趋势' },
  sma100: { name: 'SMA100', description: '100日简单移动平均线', category: '技术指标-趋势' },
  sma200: { name: 'SMA200', description: '200日简单移动平均线（长期趋势）', category: '技术指标-趋势' },

  ema12: { name: 'EMA12', description: '12日指数移动平均线（更敏感）', category: '技术指标-趋势' },
  ema26: { name: 'EMA26', description: '26日指数移动平均线', category: '技术指标-趋势' },

  // 动量类
  rsi14: { name: 'RSI(14)', description: '14周期相对强弱指数，衡量超买超卖', category: '技术指标-动量' },
  macd: { name: 'MACD', description: '快线EMA12与慢线EMA26的差，配合信号线用于趋势动量', category: '技术指标-动量' },
  macdSignal: { name: 'MACD Signal', description: 'MACD 的信号线（常为9期EMA）', category: '技术指标-动量' },
  macdHist: { name: 'MACD 柱', description: 'MACD 与信号线之差，用于判断多空力度', category: '技术指标-动量' },

  // 成交量类（示例）
  obv: { name: 'OBV', description: '能量潮指标，量价同向/背离分析', category: '技术指标-成交量' },
  vwap: { name: 'VWAP', description: '成交量加权平均价（多用于日内）', category: '技术指标-成交量' },

  // 波动性类（示例）
  bbUpper: { name: '布林上轨', description: '中轨±k倍标准差的上轨', category: '技术指标-波动性' },
  bbMiddle: { name: '布林中轨', description: '通常为 SMA20', category: '技术指标-波动性' },
  bbLower: { name: '布林下轨', description: '中轨±k倍标准差的下轨', category: '技术指标-波动性' },

  // 支撑阻力（示例）
  pivotPoint: { name: '枢轴点', description: '基于前一周期高低收计算的关键水平', category: '技术指标-支撑阻力' },
  support1: { name: '支撑位 S1', description: '第一级支撑', category: '技术指标-支撑阻力' },
  resistance1: { name: '阻力位 R1', description: '第一级阻力', category: '技术指标-支撑阻力' },

  // 均线与加权
  sma7: { name: 'SMA7', description: '7期简单移动平均', category: '技术指标-趋势' },
  sma25: { name: 'SMA25', description: '25期简单移动平均', category: '技术指标-趋势' },
  sma99: { name: 'SMA99', description: '99期简单移动平均', category: '技术指标-趋势' },
  wma20: { name: 'WMA20', description: '20期加权移动平均', category: '技术指标-趋势' },
  wma50: { name: 'WMA50', description: '50期加权移动平均', category: '技术指标-趋势' },

  ema5: { name: 'EMA5', description: '5期指数移动平均', category: '技术指标-趋势' },
  ema7: { name: 'EMA7', description: '7期指数移动平均', category: '技术指标-趋势' },
  ema10: { name: 'EMA10', description: '10期指数移动平均', category: '技术指标-趋势' },
  ema20: { name: 'EMA20', description: '20期指数移动平均', category: '技术指标-趋势' },
  ema25: { name: 'EMA25', description: '25期指数移动平均', category: '技术指标-趋势' },
  ema30: { name: 'EMA30', description: '30期指数移动平均', category: '技术指标-趋势' },
  ema50: { name: 'EMA50', description: '50期指数移动平均', category: '技术指标-趋势' },
  ema99: { name: 'EMA99', description: '99期指数移动平均', category: '技术指标-趋势' },

  // 动量与震荡
  rsi6: { name: 'RSI(6)', description: '6期相对强弱指数', category: '技术指标-动量' },
  rsi24: { name: 'RSI(24)', description: '24期相对强弱指数', category: '技术指标-动量' },

  stochK: { name: '随机指标K', description: 'Stochastic %K', category: '技术指标-动量' },
  stochD: { name: '随机指标D', description: 'Stochastic %D', category: '技术指标-动量' },

  cci14: { name: 'CCI(14)', description: '14期商品通道指数', category: '技术指标-动量' },
  cci20: { name: 'CCI(20)', description: '20期商品通道指数', category: '技术指标-动量' },
  williamsR: { name: 'Williams %R', description: '威廉指标，超买超卖', category: '技术指标-动量' },
  williamsR14: { name: 'Williams %R(14)', description: '14期威廉指标', category: '技术指标-动量' },
  mfi14: { name: 'MFI(14)', description: '14期资金流量指数', category: '技术指标-动量' },

  roc10: { name: 'ROC(10)', description: '10期价格变化率', category: '技术指标-动量' },
  roc12: { name: 'ROC(12)', description: '12期价格变化率', category: '技术指标-动量' },
  roc14: { name: 'ROC(14)', description: '14期价格变化率', category: '技术指标-动量' },

  cmf14: { name: 'CMF(14)', description: 'Chaikin Money Flow 资金流', category: '技术指标-成交量' },

  // 成交量/资金流
  adLine: { name: 'A/D Line', description: '累积/派发线', category: '技术指标-成交量' },
  vwap24h: { name: 'VWAP(24h)', description: '24小时窗口 VWAP', category: '技术指标-成交量' },
  vwap7d: { name: 'VWAP(7d)', description: '7天窗口 VWAP', category: '技术指标-成交量' },

  // 布林带与通道
  bbWidth: { name: '布林带宽度', description: '上/下轨之间的带宽', category: '技术指标-波动性' },
  bbPctB: { name: '布林%B', description: '价格在布林带内所处的百分位', category: '技术指标-波动性' },

  keltnerUpper: { name: '肯特纳上轨', description: 'Keltner Channel 上轨', category: '技术指标-波动性' },
  keltnerMiddle: { name: '肯特纳中轨', description: 'Keltner Channel 中轨', category: '技术指标-波动性' },
  keltnerLower: { name: '肯特纳下轨', description: 'Keltner Channel 下轨', category: '技术指标-波动性' },

  // 支撑阻力
  support2: { name: '支撑位 S2', description: '第二支撑位', category: '技术指标-支撑阻力' },
  support3: { name: '支撑位 S3', description: '第三支撑位', category: '技术指标-支撑阻力' },
  supportLevel: { name: '主支撑位', description: '当前计算的主支撑', category: '技术指标-支撑阻力' },
  resistance2: { name: '阻力位 R2', description: '第二阻力位', category: '技术指标-支撑阻力' },
  resistance3: { name: '阻力位 R3', description: '第三阻力位', category: '技术指标-支撑阻力' },
  resistanceLevel: { name: '主阻力位', description: '当前计算的主阻力', category: '技术指标-支撑阻力' },

  // 趋势强度/方向
  adx14: { name: 'ADX(14)', description: '14期平均趋向指标，衡量趋势强度', category: '趋势强度' },
  adx20: { name: 'ADX(20)', description: '20期平均趋向指标', category: '趋势强度' },
  plusDI: { name: '+DI', description: '正向指标，配合ADX判断趋势', category: '趋势强度' },
  plusDI14: { name: '+DI(14)', description: '14期正向指标', category: '趋势强度' },
  minusDI: { name: '-DI', description: '负向指标，配合ADX判断趋势', category: '趋势强度' },
  minusDI14: { name: '-DI(14)', description: '14期负向指标', category: '趋势强度' },
  aroonUp: { name: 'Aroon Up', description: 'Aroon 上升值', category: '趋势强度' },
  aroonDown: { name: 'Aroon Down', description: 'Aroon 下降值', category: '趋势强度' },
  aroonOscillator: { name: 'Aroon 振荡', description: 'Aroon Up - Down', category: '趋势强度' },

  volumeTrend: { name: '成交量趋势', description: 'up/down 等枚举，反映量能方向', category: '市场情绪' },
  priceTrend: { name: '价格趋势', description: 'up/down 等枚举，反映价格方向', category: '市场情绪' },
  trendSignal: { name: '趋势信号', description: '如 bullish/bearish', category: '市场情绪' },
  momentumSignal: { name: '动量信号', description: '如 strong/weak', category: '市场情绪' },

  // 情绪与衍生
  fearGreedIndex: { name: '恐惧与贪婪指数', description: '市场情绪综合指标', category: '市场情绪' },
  socialVolume: { name: '社交讨论量', description: '社媒/论坛相关讨论规模', category: '市场情绪' },
  sentimentScore: { name: '情绪评分', description: '文本/社交数据解析得分', category: '市场情绪' },

  fundingRate: { name: '资金费率', description: '永续合约多空资金费率', category: '衍生指标' },
  openInterest: { name: '未平仓合约', description: '合约持仓规模', category: '衍生指标' },
  longShortRatio: { name: '多空比', description: '多头/空头持仓或交易量比', category: '衍生指标' },

  // 估值/效率
  priceToVolumeRatio: { name: '价量比', description: '价格与成交量的比值', category: '性能指标' },
  marketCapToVolumeRatio: { name: '市值/成交额比', description: '市值与成交额之比', category: '性能指标' },

  // 风险与绩效
  riskScore: { name: '风险评分', description: '综合风险评估分值', category: '风险评估' },
  volatilityRisk: { name: '波动性风险', description: '基于波动的风险量化', category: '风险评估' },
  liquidityRisk: { name: '流动性风险', description: '基于深度与价差的风险量化', category: '风险评估' },
  concentrationRisk: { name: '集中度风险', description: '持仓/流通集中度带来的风险', category: '风险评估' },

  sharpeRatio: { name: '夏普比率', description: '超额收益/全波动风险', category: '性能指标' },
  sortinoRatio: { name: '索提诺比率', description: '超额收益/下行风险', category: '性能指标' },
  calmarRatio: { name: '卡玛比率', description: '年化收益/最大回撤', category: '性能指标' },
  maxDrawdown: { name: '最大回撤', description: '历史期间内的最大净值回撤', category: '性能指标' },
  maxDrawdownPct: { name: '最大回撤率', description: '最大回撤相对峰值的百分比', category: '性能指标' },

  // 相关性
  correlationBtc: { name: '与BTC相关性', description: '与 BTC 收益的相关系数', category: '相关性' },
  correlationEth: { name: '与ETH相关性', description: '与 ETH 收益的相关系数', category: '相关性' },
  beta: { name: 'Beta 系数', description: '相对市场基准的系统性风险', category: '相关性' },

  // 交易所信息
  exchangeCount: { name: '交易所数量', description: '该资产已上线的交易所数量', category: '交易所数据' },
  primaryExchange: { name: '主交易所', description: '主要或首发交易所', category: '交易所数据' },
  exchangeRank: { name: '交易所排名', description: '平台综合排名或质量评价', category: '交易所数据' },
  listedExchanges: { name: '已上市交易所', description: '上线的交易所列表', category: '交易所数据' },

  // 信号类说明
  macdCrossSignal: { name: 'MACD 交叉信号', description: '金叉/死叉文字信号', category: '市场情绪' },
  emaCrossSignal: { name: '均线交叉信号', description: 'EMA/SMA 交叉的文字信号', category: '市场情绪' },
  rsiSignal: { name: 'RSI 信号', description: 'RSI 超买/超卖/回落等文字信号', category: '市场情绪' },
};
